// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Po-z","badgeLink":"Qo-z","category":"Ro-z"};